import { instanceEmployee } from '../../../../services/instances';

const getArea = async (params: Record<string, any> = {}): Promise<any> => {
    const response = await instanceEmployee.get<any>('/area', { params });
    return response.data.data;
};
export { getArea };
